module.exports = __webpack_public_path__ + "img/hero.1bd693f3.webp";